export default __webpack_public_path__ + "static/media/Nothing here yet.99e3c5fc.gif";